import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
const useUrlStore = create(devtools((set, get) => ({

  drawerOpen: false,

  openDrawer: () => {
    set(() => ({
      drawerOpen: true
    }))
  },

  closeDrawer: () => {
    set(() => ({
      drawerOpen: false
    }))
  },

}), { name: 'urlStore' }))

export default useUrlStore
